export enum ALERT_TYPE {
	INFO = 'info',
	WARNING = 'warning',
	PRIMARY = 'primary',
}